import React from 'react';
import './TopControlPanel.css';

/**
 * TopControlPanel 组件
 * 
 * 功能：
 * - 顶部控制面板，包含背景音乐控制、未来阶段标签和新增节点按钮
 * - 统一管理顶部栏的所有功能
 * 
 * 特性：
 * - 透明背景设计
 * - 响应式布局
 * - 统一的粉色主题
 */

interface TopControlPanelProps {
  isPlaying: boolean; // 背景音乐播放状态
  onMusicToggle: () => void; // 音乐播放切换回调
  onAddNode: () => void; // 新增节点回调
  onVerifyIdentity?: () => void; // 验证身份回调
  permissionStatus?: 'full' | 'view' | null; // 权限状态
}

const TopControlPanel: React.FC<TopControlPanelProps> = ({ 
  isPlaying, 
  onMusicToggle, 
  onAddNode,
  onVerifyIdentity,
  permissionStatus = 'full'
}) => {
  return (
    <div className="top-control-panel">
      {/* 背景音乐控制区 */}
      <div className="music-control">
        <button 
          className={`music-button ${isPlaying ? 'playing' : ''}`} 
          onClick={onMusicToggle}
          title={isPlaying ? '暂停音乐' : '播放音乐'}
        >
          <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            {isPlaying ? (
              <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
            ) : (
              <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
            )}
          </svg>
        </button>
        <span className="music-label">背景音乐</span>
      </div>

      {/* 未来阶段标签 */}
      <div className="future-stage-label">
        <div className="future-stage-marker">
          <div className="future-stage-text">未来</div>
        </div>
      </div>

      {/* 右侧按钮区 */}
      <div className="action-control">
        {permissionStatus === 'full' ? (
          // 完整权限：显示新增节点按钮
          <button 
            className="add-node-button" 
            onClick={onAddNode}
            title="新增时间轴节点"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
            </svg>
            <span>新增节点</span>
          </button>
        ) : (
          // 浏览权限或未验证：显示验证身份按钮
          <button 
            className="verify-identity-button" 
            onClick={onVerifyIdentity}
            title="验证身份以获取完整权限"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
            </svg>
            <span>验证身份</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default TopControlPanel;